module.exports = __webpack_public_path__ + "img/user-login-svgrepo-com.17b0e376.svg";